import NavBar from '../../components/NavBar.vue'
import SideBar from '../../components/SideBar.vue'
import Breadcrumb from '../../components/BreadCrumb.vue'

export default {
  name: 'DefaultContainer',
  components: { NavBar, SideBar, Breadcrumb }
}
